import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "plot-controls" }
const _hoisted_2 = ["for", "title"]
const _hoisted_3 = ["id", "onUpdate:modelValue", "min", "max", "step", "disabled"]
const _hoisted_4 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["id", "onUpdate:modelValue", "min", "max", "step", "disabled"]
const _hoisted_7 = ["id", "onClick"]



export interface PlotControlProps {
  name?: string
  type: 'slider' | 'selector' | 'spinner'
  value: number
  min?: number
  max?: number
  step?: number
  tooltip?: string
  compute?: (params: Record<string, number>) => number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlotControls',
  props: {
    controls: {}
  },
  setup(__props: any) {



function autoCompute(controls: Record<string, PlotControlProps>): void {
  const params = Object.keys(controls).reduce((acc, key) => {
    acc[key] = controls[key].value
    return acc
  }, {} as Record<string, number>)
  Object.entries(controls).forEach(([name, control]) => {
    const button = document.getElementById('lock-' + name) as HTMLButtonElement
    const inputField = document.getElementById(
      'input-' + name
    ) as HTMLInputElement
    const isLocked = button && button.dataset.locked === 'true'
    if (control.compute && isLocked) {
      control.value = control.compute(params)
    }
    if (button) {
      inputField.disabled = isLocked
    }
  })
}

function toggleLock(
  name: string,
  controls: Record<string, PlotControlProps>
): void {
  const button = document.getElementById('lock-' + name) as HTMLButtonElement
  const isLocked = button.dataset.locked === 'true'
  const newLockedState = !isLocked
  button.dataset.locked = newLockedState.toString()
  button.textContent = newLockedState ? '🔗' : '⛓️‍💥'
  autoCompute(controls)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.controls, (control, name) => {
      return (_openBlock(), _createElementBlock("div", {
        key: name,
        class: "control-item"
      }, [
        _createElementVNode("label", {
          for: name,
          class: _normalizeClass([control.tooltip ? 'tooltip' : '']),
          title: control.tooltip || ''
        }, _toDisplayString(control.tooltip ? 'ⓘ' : '') + " " + _toDisplayString((control.name ? control.name : name) +
          // Show current value for controls that normally don't display it
          (control.type == 'slider' ? `: ${control.value}` : '')), 11, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(control.compute ? 'control-with-lock' : '')
        }, [
          (control.type === 'slider')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                id: 'input-' + name,
                "onUpdate:modelValue": ($event: any) => ((control.value) = $event),
                type: "range",
                min: control.min,
                max: control.max,
                step: control.step,
                disabled: control.compute !== undefined,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (autoCompute(__props.controls)))
              }, null, 40, _hoisted_3)), [
                [
                  _vModelText,
                  control.value,
                  void 0,
                  { number: true }
                ]
              ])
            : (control.type === 'selector')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  id: 'input-' + name,
                  "onUpdate:modelValue": ($event: any) => ((control.value) = $event),
                  disabled: control.compute !== undefined,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (autoCompute(__props.controls)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(
              { length: control.max - control.min + 1 },
              (_, i) => ({
                value: control.min + i,
                label: (control.min + i).toString(),
              })
            ), (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_5))
                  }), 128))
                ], 40, _hoisted_4)), [
                  [
                    _vModelSelect,
                    control.value,
                    void 0,
                    { number: true }
                  ]
                ])
              : (control.type === 'spinner')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    id: 'input-' + name,
                    "onUpdate:modelValue": ($event: any) => ((control.value) = $event),
                    type: "number",
                    min: control.min,
                    max: control.max,
                    step: control.step,
                    disabled: control.compute !== undefined,
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (autoCompute(__props.controls)))
                  }, null, 40, _hoisted_6)), [
                    [
                      _vModelText,
                      control.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                : _createCommentVNode("", true),
          (control.compute)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                id: 'lock-' + name,
                class: "tooltip lock-button secondary",
                "data-locked": "true",
                title: 'Auto-derive this parameter from the rest.',
                onClick: ($event: any) => (toggleLock(name as string, __props.controls))
              }, " 🔗 ", 8, _hoisted_7))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    }), 128))
  ]))
}
}

})